import { datadogLogs } from '@datadog/browser-logs';
import { isBotUserAgent, isE2ESession, isFeatureEnabled } from 'common/utils';

import { getDatadogProxy } from './datadogProxy';
import { containsReportDataSignedUrl, isReportDataSignedUrl } from './reportDataSignedUrl';

export const initDatadogLogs = () => {
  // Don't initialize Datadog in E2E test sessions, if bot detected, or if feature is disabled
  if (isE2ESession() || isBotUserAgent() || !isFeatureEnabled('DatadogEnabled')) {
    return;
  }

  datadogLogs.init({
    clientToken: window._env_.DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'natter-frontend',
    env: window._env_.VITE_APP_ENVIRONMENT,
    version: window._env_.VITE_APP_TAG,
    // Same-origin intake proxy (telemetry-relay via CloudFront /ddintake/*), gated by DatadogProxyEnabled.
    // undefined when the flag is off → SDK posts directly to Datadog.
    proxy: getDatadogProxy(),
    forwardErrorsToLogs: true,
    forwardConsoleLogs: 'all',
    forwardReports: 'all',
    sessionSampleRate: window._env_.DATADOG_LOGS_SAMPLE_RATE ? Number(window._env_.DATADOG_LOGS_SAMPLE_RATE) : 100,
    // A failed or aborted fetch of a signed report payload link is logged as `Fetch error GET <url>`
    // with the link in `http.url`; it reads the payload, quotes included, so it must not ship (CORE-569).
    beforeSend: (event) =>
      !isReportDataSignedUrl(event.http?.url) &&
      !containsReportDataSignedUrl(event.message) &&
      !containsReportDataSignedUrl(event.error?.stack),
  });

  datadogLogs.logger.setHandler(['http', 'console']);
};

export const logger = datadogLogs.logger;
